import request from 'src/api'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { formatFloat, cleanFloat, isRole } from 'src/misc'

export default () => {
  $('#offcanvasRight').on('click', '#new', function(event) {
    if ($('#offcanvasRight .tab-pane.active').attr('id') === 'contracts') {
      if (!dirty) {
        lockButton('#new_contract')
        const url = $('#contracts-link button').data('link').replace('get_contract', 'new')
        $.getScript(url)
      } else {
        confirmDirtyNav()
      }
    }
  })

  $('#mainModal').on('change', '#contract_period', function(event) {
    if (!isRole('PEM')) {
      if ($(this).val() !== 'Muu') {
        $('#mainModal #contract_period_text').closest('div').addClass('d-none')
      } else {
        $('#mainModal #contract_period_text').closest('div').removeClass('d-none')
      }
    }
  })

  $('#offcanvasRight').on('change', '#contract_work_weekdays', function(event) {
    if (!isRole('PEM')) {
      if ($(this).val() !== 'Muu') {
        $('#offcanvasRight #contracts #contract_work_weekdays_notes').prop('disabled', true)
      } else {
        $('#offcanvasRight #contracts #contract_work_weekdays_notes').prop('disabled', false)
      }
    }
  })

  $('#offcanvasRight').on('change', '#contract_contract_period', function(event) {
    if (!isRole('PEM')) {
      if ($(this).val() !== 'Muu') {
        $('#offcanvasRight #contracts #contract_contract_period_text').prop('disabled', true)
      } else {
        $('#offcanvasRight #contracts #contract_contract_period_text').prop('disabled', false)
      }
    }
  })

  $('#offcanvasRight').on('change', '#contract_price_type', function(event) {
    if (!isRole('PEM')) {
      if ($(this).val() === 'MONTH') {
        $('#contract_price').closest('div.form-group').removeClass('d-none')
        $('#contract_hour_price_weekday').closest('div.row').addClass('d-none')
        $('#contract_session_price_weekday').closest('div.row').addClass('d-none')
        $('#contract_payment_terms').prop("disabled", false)
      } else if ($(this).val() === 'HOUR') {
        $('#contract_price').closest('div.form-group').addClass('d-none')
        $('#contract_hour_price_weekday').closest('div.row').removeClass('d-none')
        $('#contract_session_price_weekday').closest('div.row').addClass('d-none')
        $('#contract_payment_terms').val('Jälkikäteen').trigger('change')
        $('#contract_payment_terms').prop("disabled", true)
      } else {
        $('#contract_price').closest('div.form-group').addClass('d-none')
        $('#contract_hour_price_weekday').closest('div.row').addClass('d-none')
        $('#contract_session_price_weekday').closest('div.row').removeClass('d-none')
        $('#contract_payment_terms').prop("disabled", false)
      }
    }
  })

  $('#offcanvasRight').on('change', '#contract_area', function(event) {
    const area = cleanFloat($(this).val())
    $(this).val(formatFloat(area, false, 0))
  })

$('#offcanvasRight').on('change', '#contract_price, #contract_hour_price_weekday, #contract_hour_price_sunday', function(event) {
    const price = cleanFloat($(this).val())
    $(this).val(formatFloat(price, true))
  })

  $('#mainModal').on('change', '#contract_business_unit_id', function(event) {
    lockButton('#contract_business_unit_id')

    const customerId = $("#mainForm").attr('action').split('/')[2]
    request.get('/customers/' + customerId + '/contracts/starttilomake_recipients?business_unit_id=' + $(this).val())
      .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      .accept('json')
      .then(res => {
        $("#contract_starttilomake_recipients").val(res.body.recipients).trigger('change')
        $('#modal_user_id').val(res.body.supervisor).trigger('change')

        unlockButton('#contract_business_unit_id')
      })
      .catch(err => {
        handleErrors(err, '#contract_business_unit_id')
      })
  })
}

// Main: poll both jobs in parallel and continue after both have finished
window.checkContractDocumentsStatus = async function(jobId1, jobId2, jobId3) {
  try {
    await Promise.all([
      waitForJob(jobId1, { intervalMs: 1000, timeoutMs: 60000 }),
      waitForJob(jobId2, { intervalMs: 1000, timeoutMs: 60000 }),
      waitForJob(jobId3, { intervalMs: 1000, timeoutMs: 60000 })
    ]);
    $('#contracts-link button').click()
  } catch (err) {
    handleErrors(err, null)
    fullscreenLoader.hide()
  }
}
